import { Text } from 'components/Typography'
import {
  Line,
  StepsGuide,
  StepsGuideItem,
  StepsGuideItemIcon,
  StepsGuideItemProgress,
  StepsGuideItemCaption,
} from './StepsGuide.styled'
import { ReactNode, useId, useState } from 'react'
import { useInterval, useWindowSize } from 'utils/hooks'
import { LayoutGroup } from 'motion/react'
import { IconName } from 'components/icon'

export type Step = { title: string; desc: ReactNode; visual: ReactNode; iconName?: IconName }

export function StepsGuideList(props: {
  steps: Step[]
  className?: string
  singleLine?: boolean
  visualHeight?: number | string
}) {
  const layoutGroupId = useId()
  const [state, setState] = useState<number>(0)
  useInterval(() => setState((state) => (state + 1 >= props.steps.length ? 0 : state + 1)), 2000)

  const { isDesktop } = useWindowSize()
  const visualHeight = props.visualHeight ?? (isDesktop ? 250 : 120)

  return (
    <StepsGuide className={props.className}>
      <Line css={{ top: visualHeight }} />
      <LayoutGroup id={layoutGroupId}>
        {props.steps.map((step, index) => (
          <StepsGuideItem key={step.title}>
            <StepsGuideItemIcon active={state === index} css={{ height: visualHeight }}>
              {step.visual}
            </StepsGuideItemIcon>

            {state === index && (
              <StepsGuideItemProgress layoutId="underline" css={{ top: visualHeight }} />
            )}

            <StepsGuideItemCaption singleLine={props.singleLine}>
              {step.title}
            </StepsGuideItemCaption>

            <Text>{step.desc}</Text>
          </StepsGuideItem>
        ))}
      </LayoutGroup>
    </StepsGuide>
  )
}
